module.exports = __webpack_public_path__ + "9141c8ae47c7a13fd9435a845be1349f.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/SIGNUS_LED-R.ttf
 ** module id = 463
 ** module chunks = 0
 **/